module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "Nft",
    "md5": "c455fa421b920c4a75793eeaf8f3c965",
    "structs": [
        {
            "name": "LockingScriptParts",
            "params": [
                {
                    "name": "code",
                    "type": "bytes"
                },
                {
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "OpPushData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "VarIntData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxInputProof",
            "params": [
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "txHash",
                    "type": "bytes"
                },
                {
                    "name": "outputIndexBytes",
                    "type": "bytes"
                },
                {
                    "name": "sequenceBytes",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxOutputProof",
            "params": [
                {
                    "name": "txHeader",
                    "type": "bytes"
                },
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "satoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "scriptHash",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        }
    ],
    "library": [
        {
            "name": "ProtoHeader",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "AmountCheckProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "Backtrace",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "NftProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TxUtil",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "function",
            "name": "unlock",
            "index": 0,
            "params": [
                {
                    "name": "txPreimage",
                    "type": "SigHashPreimage"
                },
                {
                    "name": "prevouts",
                    "type": "bytes"
                },
                {
                    "name": "prevNftInputIndex",
                    "type": "int"
                },
                {
                    "name": "prevNftAddress",
                    "type": "bytes"
                },
                {
                    "name": "nftTxHeader",
                    "type": "bytes"
                },
                {
                    "name": "nftTxInputProof",
                    "type": "TxInputProof"
                },
                {
                    "name": "prevNftTxProof",
                    "type": "TxOutputProof"
                },
                {
                    "name": "genesisScript",
                    "type": "bytes"
                },
                {
                    "name": "contractInputIndex",
                    "type": "int"
                },
                {
                    "name": "contractTxProof",
                    "type": "TxOutputProof"
                },
                {
                    "name": "amountCheckHashIndex",
                    "type": "int"
                },
                {
                    "name": "amountCheckInputIndex",
                    "type": "int"
                },
                {
                    "name": "amountCheckTxProof",
                    "type": "TxOutputProof"
                },
                {
                    "name": "amountCheckScript",
                    "type": "bytes"
                },
                {
                    "name": "senderPubKey",
                    "type": "PubKey"
                },
                {
                    "name": "senderSig",
                    "type": "Sig"
                },
                {
                    "name": "receiverAddress",
                    "type": "bytes"
                },
                {
                    "name": "nftOutputSatoshis",
                    "type": "int"
                },
                {
                    "name": "opReturnScript",
                    "type": "bytes"
                },
                {
                    "name": "changeAddress",
                    "type": "Ripemd160"
                },
                {
                    "name": "changeSatoshis",
                    "type": "int"
                },
                {
                    "name": "operation",
                    "type": "int"
                }
            ]
        },
        {
            "type": "constructor",
            "params": [
                {
                    "name": "unlockContractCodeHashArray",
                    "type": "bytes[5]"
                }
            ]
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp01/contract/nft/nft.scrypt",
    "hex": "0176018801a901ac515301402097dfd76851bf465e8f715593b217714858bbe9570ff3bd5e33840a34e20ff0262102ba79df5f8ae7604a9830f03c7933028186aede0675a16f025dc4f8be8eec0382201008ce7480da41702918d1ec8e6849ba32b4d65b1e40dc669c31a1e6306b266c557954798501145593140000000000000000000000000000000000000000517901249300790114930079589300795893007901149300790124930079529355011493007901149300795193<unlockContractCodeHashArray[0]><unlockContractCodeHashArray[1]><unlockContractCodeHashArray[2]><unlockContractCodeHashArray[3]><unlockContractCodeHashArray[4]>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",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp01/contract-desc/nft.map.json"
}